// extracted by mini-css-extract-plugin
export var content = "_aw-3";
export var list = "_aw-4";
export var settingsContent = "_aw-7";
export var settingsPanel = "_aw-8";
export var state = "_aw-6";
export var triggerBadge = "_aw-2";
export var triggerButton = "_aw-1";
export var triggerShell = "_aw-0";
export var unreadDot = "_aw-5";